module.exports = __webpack_public_path__ + "static/media/rails.4b563395.png";